import React, { Component } from "react";
import { initMap, setMarkers } from "../../../lib/here";

// website: "https://creatyonarylab.com",
// contactEmail: "admin@findclasses.co.nz",
// contactPerson: "Marina Goldburt",
// locations: [
//   { address: "41 Wood Bay road", name: "Home", id: "1" },
//   { address: "Queen street", name: "Work", id: "2" }
// ]

export default class MapDiv extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    initMap("mymap", this.props.markerSelected, this.props.onFullSelect, false);
  }
  render() {
    return (
      <React.Fragment>
        <div
          id="mymap"
          style={{
            flexGrow: 1,
            height: this.props.height || "300px",
            width: "100%"
          }}
        />
      </React.Fragment>
    );
  }
}
